import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { DeleteSurveyLanguageRPC } from "./deleteSurveyLanguageRPC";

export class DeleteSurveyLanguageRPCClientImpl extends DeleteSurveyLanguageRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: DeleteSurveyLanguageRPC.Request): Promise<LeoRPCResult<DeleteSurveyLanguageRPC.Response, DeleteSurveyLanguageRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/DeleteSurveyLanguage",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      DeleteSurveyLanguageRPC.ResponseDTO,
      DeleteSurveyLanguageRPC.Errors.ErrorsDTO,
      DeleteSurveyLanguageRPC.Response,
      DeleteSurveyLanguageRPC.Errors.Errors
    >(
      response,
      "survey/DeleteSurveyLanguage",
      DeleteSurveyLanguageRPC.Response.fromDTO,
      DeleteSurveyLanguageRPC.Errors.fromDTO
    );
  }
}
